import React, { useRef, useEffect } from "react";
import { Row, Col, Button, Input, Form } from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";
import DatePicker from "react-date-picker/dist/entry.nostyle";
import {
  CustomLabel,
  BookAppointmentButton,
} from "../../../../../../Common/style";
import AppointmentModal from "../../../AppointmentModal";
import { useIsMobile } from "../../../../../../Hooks";
import {
  scrollToTop,
  convertTo24Hour,
  getAllowedMaxTimeByMedicalSet
} from "../../../../../../Utils";
import CONSTANTS from "../../../../../../Utils/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  callIcon,
  markerIcon,
  calenderBlueIcon,
} from "../../../../../../Assets/Images";
import { PolicyDetails } from "../../../../CommonData";
import PAGE_CONSTANTS from "../../../constant";
import { getGender, getAdditionalSetList, maskPhoneNumber, maskedEmail } from "../../../../../../Utils";
import { setAppointmentDate, setAppointmentTime, setErrors, setIsModalOpen, setMobile, setEmail } from "../../../../../../Redux/BookMedicalVisit/action";
import { BookVisitDetails, AppointmentDetails } from "../../../../CommonData";
import { pickerOptionsMinutes, pickerOptionsHours, getMaxDate, getMinDate } from "../../handlers";
import "./centerBooking.css";

const CenterBookingTemplate = ({
  selectedMember,
  bookAppointment,
  tpaDetails
}) => {
  const {
    applicationID,
    policyType,
    businessType,
    inwardTypeCode,
    proposerCity,
    proposerFirstName,
    proposerInitial,
    proposerLastName,
    proposerPincode,
    proposerState,
    proposerArea,
    proposalDetails,
    policyNum,
    appSource
  } = PolicyDetails();
  const { AppointmentBookings } = AppointmentDetails()

  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const isDisablePM = getAllowedMaxTimeByMedicalSet(selectedMember?.MedicalTestSet) === PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM;
  const { [selectedMember?.MemberId]: bookState } = BookVisitDetails();
  const {
    selectedCenter,
    includedMembers,
    pinCode,
    appointmentDate,
    mobile,
    email,
    appointmentTime,
    isModalOpen,
  } = bookState || {}

  const disableSundays = ({ date }) => {
    return date?.getDay() === 0;
  }
  const toggleModal = () => {
    dispatch(setIsModalOpen({ memberId: selectedMember?.MemberId, value:!isModalOpen}));
  };
  const getAddress = () => {
    return `${selectedCenter?.address}, ${selectedCenter?.pinCode}`;
  };
  const getInsuredMemberObj = (memberDetails) => {
    const isMedicalSetAvailable =  memberDetails?.MedicalTestSetName && memberDetails?.MedicalTestSet;
    const isIncludedMember = includedMembers?.includes(memberDetails?.MemberId);
    return {
      Member_id: memberDetails?.MemberId,
      insured_id: memberDetails?.CustomerId || "",
      insured_initial: memberDetails?.InsuredInitial,
      insured_First_name: memberDetails?.FirstName,
      insured_Middle_name: memberDetails?.MiddleName,
      insured_Last_name: memberDetails?.LastName,
      insured_mobile_number: mobile,
      insured_residence_number: "",
      insured_office_number: "",
      insured_emailid: email,
      insured_pincode: pinCode,
      insured_state: memberDetails?.InsuredState,
      insured_landmark: "",
      insured_city: memberDetails?.InsuredCity,
      insured_address1: "",
      insured_address2: "",
      insured_address3: null,
      insured_dob: memberDetails?.InsuredDob ? moment(memberDetails?.InsuredDob,CONSTANTS?.FORMAT_DOB).format(CONSTANTS?.FORMAT_DOB_SLASH) : "",
      insured_age: memberDetails?.InsuredAge,
      insured_gender: getGender(memberDetails?.InsuredGender),
      Priority_hniflag: false,
      Appointment_type: "PPMC",
      CallMe_Now_flag: false,
      Appointment_preferred_date1: isIncludedMember ?  moment(
        appointmentDate,
        CONSTANTS?.FORMAT_DOB
      ).format(CONSTANTS?.FORMAT_DOB_SLASH) : "",
      Appointment_preferred_time1: isIncludedMember ? convertTo24Hour(
        appointmentTime?.hour,
        appointmentTime?.minute,
        appointmentTime?.meridiem
      ) : "",
      Appointment_preferred_date2: "",
      Appointment_preferred_time2: "00:00:00",
      Appointment_preferred_date3: "",
      Appointment_preferred_time3: "00:00:00",
      Preferred_Gender: "M",
      PPMC_Test_Decription: memberDetails?.MedicalTestSetName,
      PPMC_test_set: memberDetails?.MedicalTestSet,
      tpa_code: tpaDetails?.tpa,
      tpa_identifier: `${tpaDetails?.tpa}-${PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE}`,
      visit_type: PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE,
      home_address1: "",
      home_address2: "",
      Home_address3: null,
      Home_city: "",
      Home_state: "",
      Home_pincode: "",
      Preferred_DC_state: null,
      preferred_city: null,
      preferred_dc_name: isIncludedMember ? selectedCenter?.name : "",
      preferred_dc_code: isIncludedMember ? selectedCenter?.dcCode : "",
      dcAddress: isIncludedMember ? getAddress() : null,
      Additional_test: !isMedicalSetAvailable ? memberDetails?.MedicalTest : null,
      Repeattest: "False",
      additional_field1: null,
      additional_field2: null,
      additional_field3: null,
      additional_field4: null,
      additional_field5: null,
      additional_field6: null,
      additional_field7: null,
      additional_field8: null,
      additional_field9: null,
      additional_field10: null,
      Additional_test_Set: !isMedicalSetAvailable ? getAdditionalSetList(memberDetails?.MedicalTest) : null,
    };
  };
  const getInsuredMemberInfo = () => {
    const AlreadyBookedIdList = AppointmentBookings?.filter((item) => item?.Appointment_preferred_time1)?.map((booking) => booking?.Member_id);
    const filteredInsuredMember = proposalDetails?.MemberDetails?.filter(
      (memberItem) =>
        ((memberItem?.MedicalTestSet && memberItem?.MedicalTestSetName) ||
          memberItem?.MedicalTest) &&
        !AlreadyBookedIdList?.includes(memberItem?.MemberId)
    )
    const insuredMembersList = filteredInsuredMember?.map((memberDetails) => getInsuredMemberObj(memberDetails));
    return insuredMembersList;
  };
  const handleAppointmentBooking = () => {
    const requestPayload = {
      Application_Number: applicationID,
      policy_type: policyType,
      Business_Type: businessType || "Urban",
      Inward_Type: inwardTypeCode,
      Proposer_initial: proposerInitial,
      Proposer_Name: `${proposerFirstName} ${proposerLastName}`,
      Proposer_Mobile_number: proposalDetails?.ProposerMobile,
      Proposer_EmailId: proposalDetails?.ProposerEmail,
      Proposer_City: proposerCity,
      Proposer_State: proposerState,
      Proposer_pincode: proposerPincode,
      Proposer_Area: proposerArea,
      Lead_Id: null,
      policy_no: policyNum,
      source: appSource,
      Insured_Info: getInsuredMemberInfo(),
    /*   Agent_Info: [
        {
          Agent_FirstName: "",
          Agent_LastName: "",
          Agent_Code: "",
          Agent_Mobile_No: "",
          Agent_Email: "",
          HNI_agent: "",
          RM_FirstName: "",
          RM_LastName: "",
          RM_Contact_Number: "",
          RM_Email: null,
        },
      ], */
      HNIFlag: "NO",
    };
    if(getInsuredMemberInfo()?.length){
      bookAppointment(requestPayload, tpaDetails?.tpa);
      toggleModal();
    }
  };
  const onTimeChange = (type, value) => {
    switch (type) {
      case "HOUR":
        const isResetMinute = ((value === "05" &&
          appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM) || (value === "11" &&
            appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM));
        dispatch(
          setAppointmentTime({
            memberId: selectedMember?.MemberId,
            value: {
              ...appointmentTime,
              ...(isResetMinute && {minute: `00`}),
              hour: value,
            },
          })
        );
        break;
      case "MINUTE":
        dispatch(
          setAppointmentTime({
            memberId: selectedMember?.MemberId,
            value: {
              ...appointmentTime,
              minute: value,
            },
          })
        );
      break;
      case "MERIDIEM":
        dispatch(
          setAppointmentTime({
            memberId: selectedMember?.MemberId,
            value: {
              hour: pickerOptionsHours(value)?.[0],
              minute: `00`,
              meridiem: value,
            },
          })
        );
        break;
      default:
        break;
    }
  };
  const onDateChange = (e) => {
    dispatch(setAppointmentDate({memberId: selectedMember?.MemberId, value: moment(e).format(CONSTANTS.FORMAT_DOB)}));
  };

  const datepickerRefApt = useRef(null);
  function handleClickDatepickerIcon(datePicker) {
    const datepickerElement = datePicker.current;
    datepickerElement.toggleCalendar();
  }
  
  const onFinish = (values) => {
    toggleModal();
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if(!appointmentDate){
      dispatch(setAppointmentDate({memberId: selectedMember?.MemberId, value: moment(getMinDate(true)).format(CONSTANTS.FORMAT_DOB)}));
    }
    scrollToTop(100);
  }, []);

  useEffect(() => {
    if(proposalDetails?.ProposerEmail && !email){
      dispatch(setEmail({memberId: selectedMember?.MemberId, value: proposalDetails?.ProposerEmail}));
    }
    if(proposalDetails?.ProposerMobile && !mobile){
      dispatch(setMobile({memberId: selectedMember?.MemberId, value: proposalDetails?.ProposerMobile}));
    }
  },[proposalDetails])

  return (
    <>
      <div className="dc-selected-block">
        <Row>
          <CustomLabel font_size="16" font_weight="bold">
            {selectedCenter?.name}
          </CustomLabel>
        </Row>
        <Row gutter={[12, 10]}>
          <Col md={20} lg={13} style={{ marginTop: "16px" }}>
            <Row>
              <Col xs={2}>
                <img src={markerIcon} alt={"marker"} />
              </Col>
              <Col xs={16} sm={18} md={22}>
                <CustomLabel font_size="14" font_weight="normal">
                  {getAddress()}
                </CustomLabel>
              </Col>
            </Row>
            {selectedCenter?.contactNo && (
              <Row>
                <Col xs={2} style={{ marginTop: "12px" }}>
                  <img src={callIcon} alt={"call"} />
                </Col>
                <Col xs={16} sm={18} md={12} style={{ marginTop: "12px" }}>
                  <CustomLabel font_size="14" font_weight="normal">
                    {selectedCenter?.contactNo}
                  </CustomLabel>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </div>
      {isMobile && <div className="dc-selected-divider" />}
      <Form
        name="bookVisit"
        autoComplete="off"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <CustomLabel
          font_size="18"
          font_weight="bold"
          style={{ marginTop: "38px", marginBottom: "10px" }}
        >
          {"3. Select Preferred Date"}
        </CustomLabel>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <div className="input pl-2 pr-2 date_open">
            <DatePicker
              ref={datepickerRefApt}
              calendarType={"US"}
              name="appointmentDate"
              id={"appointeeDate"}
              onChange={onDateChange}
              value={
                appointmentDate
                  ? moment(appointmentDate, CONSTANTS?.FORMAT_DOB).toDate()
                  : ""
              }
              maxLength="10"
              clearIcon={null}
              inline
              monthsShown={2}
              minDate={getMinDate(true)}
              maxDate={getMaxDate(true)}
              defaultView="month"
              calendarIcon={null}
              format="dd/MM/yyyy"
              dayPlaceholder="DD"
              monthPlaceholder="MM"
              yearPlaceholder="YYYY"
              tileDisabled={disableSundays}
            />
          </div>
          <span className="open_picker" style={{ paddingLeft: "10px" }}>
            <img
              src={calenderBlueIcon}
              onClick={() => handleClickDatepickerIcon(datepickerRefApt)}
              alt="calendar"
            />
          </span>
        </div>
        <CustomLabel
          font_size="18"
          font_weight="bold"
          style={{ marginTop: "5px", marginBottom: "10px" }}
        >
          {"4. Select Preferred Time"}
        </CustomLabel>
        <div className="input_wrap time-picker-container">
          <label className="input_other">
            <select
              name="hour"
              id="hourTime"
              className="time-pick-dropdown"
              data-validation="required"
              value={appointmentTime?.hour}
              onChange={(e) => onTimeChange("HOUR", e?.target?.value)}
            >
              {pickerOptionsHours(appointmentTime?.meridiem)?.map(
                (item, index) => (
                  <option key={item + index} value={item}>
                    {item}
                  </option>
                )
              )}
            </select>
          </label>
          <label className="input_other ml-1">
            <select
              name="minutes"
              id="minutesTime"
              className="time-pick-dropdown"
              value={appointmentTime?.minute}
              onChange={(e) => onTimeChange("MINUTE", e?.target?.value)}
            >
              {pickerOptionsMinutes(
                (appointmentTime?.hour === "05" &&
                  appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM) ||
                  (appointmentTime?.hour === "11" &&
                    appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM)
              )}
            </select>
          </label>
          <div
            className="mt_booking_detail"
            style={{ paddingLeft: "0px", width: "unset" }}
          >
            <input
              className="titleRadio"
              id={"am"}
              value={"AM"}
              type="radio"
              checked={
                appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM
              }
              required
              name="nameTitle"
              data-validation="required"
            />
            <label
              onClick={() =>
                onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_AM)
              }
              className="cigna_button"
              style={{
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }}
            >
              {"AM"}
            </label>
            <input
              className="titleRadio"
              id={"pm"}
              value={"PM"}
              checked={
                appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM
              }
              type="radio"
              required
              name="nameTitle"
              data-validation="required"
            />
            <label
              onClick={
                !isDisablePM
                  ? () => onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_PM)
                  : null
              }
              className={
                isDisablePM ? "cigna_button meridiem-disable" : "cigna_button"
              }
              style={{
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              {"PM"}
            </label>
          </div>
        </div>
        <Form.Item>
          <BookAppointmentButton disable={false}>
            <Button type="text" disabled={false} htmlType="submit">
              {"Book Appointment"}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ marginLeft: "15px" }}
              />
            </Button>
          </BookAppointmentButton>
        </Form.Item>
      </Form>
      <AppointmentModal
        open={isModalOpen}
        onClose={toggleModal}
        date={appointmentDate}
        time={appointmentTime}
        address={getAddress()}
        clinicName={selectedCenter?.name}
        dcContactNo={selectedCenter?.contactNo}
        mobile={maskPhoneNumber(mobile)}
        email={maskedEmail(email)}
        appointmentType={PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE}
        onBooking={handleAppointmentBooking}
      />
    </>
  );
};

export default CenterBookingTemplate;
